import Select from '../../../common/Select';
import Currency from '../../../common/Currency';
import DatePicker from '../../../common/DatePicker';
import SimpleDatePicker from "../../../common/SimpleDatePicker";

export default {
    id: 0,

    name: 'insurance_plans',
    _system: {
        name: 'Insurance Plans',
        relatedTo: 'insurance_plans',
    },
    year: {
        label: 'Year',
        hideLabel: true,
        placeholder: 'Add Year',
        dateFormat: 'YYYY',
        utc: true,
        timeFormat: false,
        viewMode: 'years',
        system: {
            component: SimpleDatePicker,
            name: 'year',
            relatedTo: 'insurance_plans'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'year',
        rules: {
            title: 'Year field'
        }
    },
    type: {
        label: 'Type',
        hideLabel: true,
        placeholder: 'Add Type',
        system: {
            component: Select,
            name: 'type',
            relatedTo: 'insurance_plans'
        },
        value: '',
        source: [
            {"value": "Medical Plan", "text": "Medical Plan"},
            {"value": "Vision", "text": "Vision"},
            {"value": "Dental", "text": "Dental"}
        ],
        errors: [],
        type: 'text',
        name: 'type',
        rules: {
            title: 'Type field'
        },
        grid: {
            className: 'col col-3'
        }
    },
    paid_by: {
        label: 'Paid By',
        hideLabel: true,
        placeholder: 'Add Paid By',
        system: {
            component: Select,
            name: 'paid_by',
            relatedTo: 'insurance_plans'
        },
        value: '',
        source: [
            {"value": "Client", "text": "Client"},
            {"value": "Employee", "text": "Employee"}
        ],
        errors: [],
        type: 'text',
        name: 'paid_by',
        rules: {
            title: 'Paid By field'
        },
        grid: {
            className: 'col col-3'
        }
    },
    total: {
        prefix: '$',
        label: 'Total',
        hideLabel: true,
        placeholder: 'Add Total',
        system: {
            component: Currency,
            name: 'total',
            relatedTo: 'past_raises'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'total',
        rules: {
            title: 'Total field',
            ignoreNull: true,
            format: /^[0-9,.]+$/
        },
        grid: {
            className: 'col col-3'
        }
    }

}



// WEBPACK FOOTER //
// ./src/containers/Employee/fields/insurance_plans.js